var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTabCategorySelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#343A40",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.172 7.947c.487 0 .863-.143 1.128-.43.265-.286.397-.676.397-1.17V5.208c0-.48-.132-.865-.397-1.155-.265-.29-.641-.435-1.128-.435H3.414c-.48 0-.854.145-1.123.435-.268.29-.403.675-.403 1.155v1.139c0 .494.131.884.393 1.17.261.287.639.43 1.133.43h16.758zm-2.718 13.836c.917 0 1.615-.238 2.095-.714.48-.476.72-1.173.72-2.09V9H3.316v9.98c0 .923.238 1.622.715 2.094.476.473 1.176.71 2.1.71h11.322zm-2.202-9.4H8.334c-.18 0-.322-.055-.43-.166-.107-.11-.161-.26-.161-.446v-.29c0-.186.054-.334.161-.445.108-.111.25-.167.43-.167h6.918c.179 0 .322.056.43.167.107.11.16.26.16.445v.29c0 .187-.053.335-.16.446-.108.111-.251.167-.43.167z",
    transform: "translate(-120 -1887) translate(0 1880) translate(95 1) translate(21 6) translate(4)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTabCategorySelected);
export default __webpack_public_path__ + "static/media/ic_tab_category_selected.6a451301431f2602e8b4f23d28d5ec79.svg";
export { ForwardRef as ReactComponent };